import React, { useState , useEffect} from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import axios from 'axios';
import { API_HOST } from '../../consts';
import { CSVLink } from 'react-csv';
// import GetAppIcon from '@material-ui/icons/GetApp';
import { Button } from '@material-ui/core';
import InsufficientData from '../../components/InsufficientData';
import Loading from '../../components/Loading';
import styled from 'styled-components';



const DivLoading = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  justify-content: center;
  align-items: center;
`;

const ReportGraphLine = ({
  tipo,
  etapa,
  turma,
  dre,
  ano,
  escola,
  disciplina,
  update,
  relatorio,
  externalData,
  shoudFetch = true
}) => {
  const [dados, setDados] = useState(externalData?externalData:undefined);
  const [fetched, setFetched] = useState(false);
  const title =
    tipo === 'dre-escolas'
      ? ''
      : tipo === 'dre-turmas'
        ? 'Proficiências entre turmas'
        : "";
  const min = window.location.host.includes('sesi') ? 100 : 0;
  const indexEtapa = (etapa) => {
    let index = [13, 9, 5];
    let response = 0;
    index.forEach(function (element) {
      if (element >= etapa) {
        response = element;
      }
    });
    return response;
  };


  useEffect(() => {
    if(shoudFetch){
    fetchData();
  }
   }, [update]);

  const parametros = {
    enem: {
      'Linguagens, Códigos e suas Tecnologias': 472.92,
      1: 472.92,
      'Matemática e suas Tecnologias': 493.01,
      2: 493.01
    }
  };
  class handleChartData {
    constructor() {
      this.variavel = [];
      this.variavel2 = [];
    }
    mediaDres() {
      const dadosList = [];
      let total = 0;
      if (dados) {
        dados.forEach((dado) => {
          dadosList.push(dado.data[0][1]);
        });
        return (
          dadosList.reduce((total, value) => total + value, 0) /
          dadosList.length
          );
        }
    }
    getNota(parametros, ano, disciplina) {
      if (ano && (ano == 3 || ano == '3')) {
        return parametros['enem'][disciplina];
      }
    }
    formatData() {
      let returnData = [];
      let media = handleDataClass.mediaDres();
      let parametro = handleDataClass.getNota(parametros, ano, disciplina);
      if (dados) {
        for (let dado of dados) {
          returnData.push(dado.data[0][1]);
          if (!this.variavel || this.variavel.length < returnData.length) {
            this.variavel.push(media);
            this.variavel2.push(parametro);
          }
        }
        return returnData;
      }
    }

    listDreNames() {
      let dreNames = [];
      if (dados) {
        dados.forEach((dado) => {
          dreNames.push(dado.name);
        });
        return dreNames;
      }
    }
  }
  const handleDataClass = new handleChartData();



  const mediaNacional = dados && dados[0] && dados[0].media_nacional !== undefined
  ? dados[0].media_nacional.toFixed(2)
  : 'N/A';
  const mediaRegional = (dados && (dados.length>=1) && (dados[0].media_regional !== undefined && dados[0].media_regional.length >= 1)) ? dados[0].media_regional.toFixed(2) : 'N/A';

  const dadosCSV = [];
  dados &&
    dados.map((dado) => {
      dadosCSV.push({
        NOME: dado.name,
        MÉDIA: dado.data[0][1] && dado.data[0][1].toFixed(2)
      });
    });

  const fetchData = () => {
    const params = {
      tipo: tipo,
      etapa: etapa,
      turma: turma,
      dre: dre,
      ano: ano,
      escola: escola,
      disciplina: disciplina
    };
    axios
      .get(`${API_HOST}/avalia/estudante/get_notas_to_chart`, { params })
      .then((response) => {
        setDados(response.data.data);

        setFetched(true);
      })
      .catch((err) => {
        setFetched(true)
      });
  };

  const mapped =
    dados &&
    dados.reduce((r, a) => {
      r[a.name] = [...(r[a.name] || []), a];
      r[a.data] = [...(r[a.data] || []), a];

      return r;
    }, {});

  if (!fetched && shoudFetch) {
    fetchData();
  }
  const media = handleDataClass.mediaDres();
  const formatedData = handleDataClass.formatData();
  const options = {

    title: {
      text: title,
      align: 'center'
    },
    subtitle: {
      text: ''
    },
    xAxis: [
      {
        categories: handleDataClass.listDreNames(),
        crosshair: true
      }
    ],
    yAxis: [

      {
        plotLines: [{
          color: '#4C9DA2',
          width:  2,
          value: mediaNacional,
          zIndex: 65,
          label: {
              text: `Média da Rede: ${mediaNacional}`,
              y: -1,
              x:-500,
              align: 'right',
              style: {color:'#4C9DA2', fontSize: '23px', fontWeight: 'bold', fontFamily: 'Verdana, sans-serif'},
          }
      },
      {
          color: '#FF8B5E',
          width: 2,
          value: mediaRegional,
          zIndex: 5,
          label: {
              y: -1,
              x:-170,
              text: tipo&&tipo=='dre-turmas'?`Média da Turma: ${mediaRegional}`:`Média Regional: ${mediaRegional}`,
              align: 'right',
              style: {color:'#FF8B5E', fontSize: '23px', fontWeight: 'bold', fontFamily: 'Verdana, sans-serif'},

          }
      },
      ],
        // Primary yAxis
        labels: {
          // format: '{value}°C',
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        },
        min: min,
        title: {
          text: '  ',
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      },
      {
        // Secondary yAxis
        title: {
          text: '  ',
          style: {
            color: Highcharts.getOptions().colors[0]
          }
        },
        labels: {
          format: ' ',
          style: {
            color: Highcharts.getOptions().colors[0]
          }
        },
        opposite: true
      }
    ],
    tooltip: {
      shared: true,
      formatter: function () {
        var points = this.points;
        var pointsLength = points.length;
        var tooltipMarkup = pointsLength
          ? '<span style="font-size: 10px">' + points[0].key + '</span><br/>'
          : '';
        var index;
        var y_value;

        for (index = 0; index < pointsLength; index += 1) {
          y_value = points[index].y.toFixed(2);

          tooltipMarkup +=
            '<span style="color:' +
            points[index].series.color +
            '">\u25CF</span> ' +
            points[index].series.name +
            ': <b>' +
            y_value +
            '</b><br/>';
        }

        return tooltipMarkup;
      }
    },
    legend: {
      align: 'center',
      verticalAlign: 'bottom',
      floating: false,
      backgroundColor:
        Highcharts.defaultOptions.legend.backgroundColor || // theme
        'rgba(255,255,255,0.25)'
    },
    series: [
      {
        name: relatorio === "dre" ? 'Média da Escola' : tipo=='dre-turmas'?`Média da Turma`:`Média Regional`,
        type: 'column',
        data: ano && handleDataClass.formatData(),
        dataLabels: {
          enabled: true,
          rotation: -90,
          color: '#000000',
          align: 'right',
          format: '{point.y:.1f}', // one decimal
          y: 150,
          style: {
            fontSize: '23px',
            fontFamily: 'Verdana, sans-serif'
          }
        }
      },
    ]
  };

  return (!fetched && dados==undefined) ? (
    <DivLoading>
      <Loading />
    </DivLoading>
  ) : dados !== undefined ? (
    <>
        <div style={{ height: 'auto' }}>
          <HighchartsReact
            highcharts={Highcharts}
            options={options}
            containerProps={{ style: { height: '700px' } }}
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button>
            <CSVLink data={dadosCSV} filename={'Comparação de proficiência'}>
              Baixar gráfico em CSV
            </CSVLink>
          </Button>
        </div>
    </>
   ) : (
    <div style={{ height: 'auto' }}>
      <InsufficientData />
    </div>
  );
};

export default ReportGraphLine;
